// -------------------------------------------- IMPORT FILES START --------------------------------------------------------------
// ## Import Files
import $api from "../Api";
import ResponseChecker from "../Middlewares/ResponseChecker";
import { defaultMessages } from "../enums/responseMessages.js";

import Endpoints from "../Endpoints";
// -------------------------------------------- IMPORT FILES ENDED --------------------------------------------------------------

// ## Company
/**
 *
 * @param {{params: object, query: {page: number, limit: number, search: string}}} option
 *
 * @returns
 */
export const GetAll = async (option) => {
  // v1 ** deprecated endpoints is ParasutAccount. If you want to use it, please use ParasutAccount.GetAll, instead of Company.GetAll
  // companies that used in v1 version, Request must be ParasutAccount.GetAll;
  // for v2 version, Request must be Company.GetAll

  let endpoint = Endpoints.Company.GetAll(option);

  const version = localStorage.getItem("version");
  // companies which is version v1 must be use this endpoint ** deprecated endpoints
  if (version === "v1") endpoint = Endpoints.ParasutAccount.GetAll(option);

  const response = await $api.get(endpoint);

  // v1 response must be change according to v2 response;
  if (version === "v1" && response.message === "OK") {
    response.data.items = response.data.items.map((item) => ({
      ...item,
      name: item.brandName,
    }));
  }

  const checker = await ResponseChecker(defaultMessages, response);

  return checker;
};

export default {
  GetAll,
};
